import { Box, Flex, Input, Spinner } from "@chakra-ui/react";
import { DroppableBox } from "components/containers/InspectionFormat/containers/LayoutFrameBuilder";
import { SOURCE } from "components/containers/InspectionFormat/Content/SettingPinLayoutFrame/context/pinLayoutFrameReducer";
import FloatNumberIcon from "components/icon/FloatNumberIcon";
import NumbericIcon from "components/icon/NumericIcon";
import { memo } from "react";
import FieldNumberPreviewWrapper from "../../../components/FieldNumberPreviewWrapper";
import { useInputValue } from "../../../hooks/useInputValue";
import { DataType } from "../../../setup/define";
import { FieldPreviewProps } from "../../types";

interface InputPreviewerProps extends FieldPreviewProps<string> {}

const InputPreviewer: React.FC<InputPreviewerProps> = ({
  item,
  value,
  onChange,
  isLoading,
  isReadOnly,
  isDraggable,
  index,
  prevItemResultCount,
  allItemResultCount,
}) => {
  const controller = useInputValue({ value, onChange, isReadOnly });

  if (isDraggable) {
    return (
      <FieldNumberPreviewWrapper
        title={item.name}
        index={index}
        prevItemResultCount={prevItemResultCount}
        allItemResultCount={allItemResultCount}
      >
        <DroppableBox
          id={item.id}
          flex={1}
          name={item.name}
          icon={
            item.dataType === DataType.NUMBER_INT ? (
              <NumbericIcon w="3rem" h="3rem" />
            ) : (
              <FloatNumberIcon w="3rem" h="3rem" />
            )
          }
          source={SOURCE.INSPECTION_FORM}
        >
          <Input
            className="draggable-area"
            isReadOnly={isReadOnly}
            backgroundColor="white"
            height="4rem"
            maxWidth="27rem"
            placeholder={item.dataType === DataType.NUMBER_INT ? "0" : "0.0"}
            textAlign="right"
            borderColor="#D4D4D4"
          />
        </DroppableBox>
      </FieldNumberPreviewWrapper>
    );
  }

  return (
    <FieldNumberPreviewWrapper
      title={item.name}
      index={index}
      prevItemResultCount={prevItemResultCount}
      allItemResultCount={allItemResultCount}
    >
      <Box position="relative" maxWidth="25.6rem" minWidth="25.6rem">
        <Input
          isReadOnly={isReadOnly}
          textAlign="right"
          placeholder={item.dataType === DataType.NUMBER_INT ? "0" : "0.0"}
          backgroundColor="white"
          height="4rem"
          width="31.5rem"
          maxW={"100%"}
          type="number"
          color="#171717"
          fontSize={"1.6rem"}
          _readOnly={{
            cursor: "pointer",
          }}
          borderColor="#D4D4D4"
          {...controller}
          onKeyPress={(evt) => {
            if (evt.key === "e") {
              evt.preventDefault();
            }
          }}
          onChange={(e) => {
            const value = e.target.value;
            if (
              value &&
              item.dataType === DataType.NUMBER_INT &&
              !/^-?[0-9]+$/.test(value)
            ) {
              return;
            }

            controller.onChange(value);
          }}
          paddingRight={isLoading ? "3rem" : "1rem"}
        />
        {isLoading && (
          <Flex
            justifyContent={"center"}
            alignItems={"center"}
            position={"absolute"}
            right={0}
            top={0}
            w={"3rem"}
            h="100%"
            zIndex={10}
          >
            <Spinner />
          </Flex>
        )}
      </Box>
    </FieldNumberPreviewWrapper>
  );
};

export default memo(InputPreviewer);
